module.exports = __webpack_public_path__ + "static/media/stem-question-sample.a9124d50.png";